
export const phpVersion = "8.3";
export const phpVersionFull = "8.3.11";
